import { useQuery } from "@apollo/client/react";import React, { useEffect, useMemo } from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Box } from "@mui/material";
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { InfoBox } from "./InfoBox";

import { GET_COMENTARIOS } from "../../../data/graphQL/queries/GestionAsistencial/getComentarios";
import moment from "moment";

export function CommentHistoryDialog({
  open,
  idPaciente,
  idDelegacion,
  handleCloseDialog,
  handleOpenAddCommentDialog
}) {

  const { data: comentarios } = useQuery(GET_COMENTARIOS, {
    fetchPolicy: 'network-only',
    variables: {
      idDelegacion: idDelegacion,
      idPaciente: idPaciente
    }
  });

  const envioComentarios = useMemo(() => {
    return comentarios?.envioComentarios;
  }, [comentarios]);

  return (
    <CustomDialog
      title="Historial de comentario"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      cancelText="Cerrar"
      acceptText="Nuevo comentario"
      onAccept={handleOpenAddCommentDialog}
      acceptLoading={false}>
      
      <Box display="flex" flexDirection="column" gap="20px" width={1}>
        {envioComentarios?.map((comentario) =>
        <Box display="flex" alignItems="baseline" gap="15px">
            <Box display="flex" alignItems="center" gap="5px">
              <CalendarTodayIcon sx={{ fontSize: "12px" }} />
              <p style={{ fontSize: "12px" }}>{moment(comentario.fecha).format('DD/MM/YYYY')}</p>
            </Box>

            <Box
            sx={{
              p: "10px",
              width: 1,
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              borderRadius: "5px",
              border: "1px solid #E0E1E3"
            }}>
            
              <InfoBox label="Usuario" value={comentario.usuario} />
              <InfoBox label="Comentario" value={comentario.comentario} />
            </Box>
          </Box>
        )}
      </Box>
    </CustomDialog>);

}